import { Environment } from 'models/Environment';
import { AppConfig } from 'models/AppConfig';
import { supportedRemoteApps } from './remoteApplications';

const APP_CONFIG: Record<Environment, AppConfig> = {
  local: {
    proxyUrl: 'http://localhost:8000',
    appEnvironment: 'local',
    qnaLibraryUrl: 'https://int5-questions-and-announcements-ui.awsmanqenp.manheim.com/questionsAndAnnouncements.js',
    qnaEnvironment: 'integration5',
    traFormUrl: 'https://integration1.api.manheim.com/forms/tra/latest',
    certFormUrl: 'https://integration1.api.manheim.com/forms/manheim-certification/latest',
    imageGuideBaseUrl: 'https://int5-image-guides.awsvivisionnp.manheim.com',
    remoteAppsList: supportedRemoteApps('local'),
    newRelicAppId: '1431889214'
  },
  ite: {
    proxyUrl: 'https://checkpoint-bff.manheim.man-silo5.com',
    appEnvironment: 'ite',
    qnaLibraryUrl: 'https://int5-questions-and-announcements-ui.awsmanqenp.manheim.com/questionsAndAnnouncements.js',
    qnaEnvironment: 'integration5',
    traFormUrl: 'https://integration5.api.manheim.com/forms/tra/latest',
    certFormUrl: 'https://integration5.api.manheim.com/forms/manheim-certification/latest',
    imageGuideBaseUrl: 'https://int5-image-guides.awsvivisionnp.manheim.com',
    remoteAppsList: supportedRemoteApps('ite'),
    newRelicAppId: '1431889214'
  },
  uat: {
    proxyUrl: 'https://checkpoint-bff.manheim.man-uat.com',
    appEnvironment: 'uat',
    qnaLibraryUrl: 'https://uat-questions-and-announcements-ui.awsmanqe.manheim.com/questionsAndAnnouncements.js',
    qnaEnvironment: 'uat',
    traFormUrl: 'https://uat.api.manheim.com/forms/tra/latest',
    certFormUrl: 'https://uat.api.manheim.com/forms/manheim-certification/latest',
    imageGuideBaseUrl: 'https://uat-image-guides.awsvivision.manheim.com',
    remoteAppsList: supportedRemoteApps('uat'),
    newRelicAppId: '1431889215'
  },
  prod: {
    proxyUrl: 'https://checkpoint-bff.manheim.com',
    appEnvironment: 'prod',
    qnaLibraryUrl: 'https://prod-questions-and-announcements-ui.awsmanqe.manheim.com/questionsAndAnnouncements.js',
    qnaEnvironment: 'production',
    traFormUrl: 'https://api.manheim.com/forms/tra/latest',
    certFormUrl: 'https://api.manheim.com/forms/manheim-certification/latest',
    imageGuideBaseUrl: 'https://prod-image-guides.awsvivision.manheim.com',
    remoteAppsList: supportedRemoteApps('prod'),
    newRelicAppId: '1431889217'
  }
};

export const appConfigFor = (environment: Environment) => {
  return APP_CONFIG[environment];
};
